interface Props {
  className?: string;
}

export default function CalendarBookingsIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.38235 4.3354C2.17174 4.3354 1.96975 4.40563 1.82083 4.53064C1.6719 4.65565 1.58824 4.82521 1.58824 5.002V23.0002C1.58824 23.177 1.6719 23.3466 1.82083 23.4716C1.96975 23.5966 2.17174 23.6668 2.38235 23.6668H24.6176C25.0544 23.6668 25.4118 23.3675 25.4118 22.9989V5.00333C25.4118 4.63404 25.0544 4.3354 24.6176 4.3354H21.4412V3.0022H24.6176C25.9343 3.0022 27 3.90011 27 5.00333V22.9989C27.0002 23.2616 26.9387 23.5218 26.8191 23.7646C26.6995 24.0074 26.524 24.228 26.3028 24.4138C26.0815 24.5997 25.8188 24.7471 25.5297 24.8477C25.2406 24.9483 24.9306 25 24.6176 25H2.38235C1.75051 25 1.14455 24.7893 0.697775 24.4143C0.250997 24.0393 0 23.5306 0 23.0002V5.002C0 4.47162 0.250997 3.96296 0.697775 3.58793C1.14455 3.21289 1.75051 3.0022 2.38235 3.0022H8.73529V4.3354H2.38235ZM21.4412 4.3354H8.73529V3.0022H21.4412V4.3354Z"
        fill="currentColor"
      />
      <path
        d="M6 0.5C6 0.5 6.77898 0.5 7 0.5C7.22102 0.5 7.66663 0.5 7.66663 0.5V7L6 7V0.5ZM19.3333 0.5H20H21V7H19.3333V0.5Z"
        fill="currentColor"
      />
      <rect x="11" y="9" width="5" height="5" fill="currentColor" />
      <rect x="11" y="16" width="5" height="5" fill="currentColor" />
      <rect x="18" y="9" width="5" height="5" fill="currentColor" />
      <rect x="4" y="9" width="5" height="5" fill="currentColor" />
      <rect x="4" y="16" width="5" height="5" fill="currentColor" />
    </svg>
  );
}
